import React from 'react';
import { NavLink } from 'react-router-dom';
import classes from './Navbar.css';

const Navbar = (props) => {
	return (
         <nav role="navigation" aria-label="navigation" className={classes.Navbar}>
           <NavLink exact to="/" activeStyle={{ boxShadow: '0 -5px 0px inset rgb(51, 203, 152)' }} aria-label="Global">Global</NavLink>
           <NavLink exact to="/stats" activeStyle={{ boxShadow: '0 -5px 0px inset rgb(51, 203, 152)' }} aria-label="By Country">By Country</NavLink>
         </nav>
	)
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js